import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import { i18n } from './i18n'
import './assets/main.css'

// Global error handler for stale custom scripts (branding scripts from old tours)
// that reference undefined globals (e.g., zaloJSV2). Reloads the page to re-fetch fresh assets.
if (typeof window !== 'undefined') {
  window.onerror = (msg, src, line, col, err) => {
    const isRefError = msg?.includes("Can't find variable") || msg?.includes('is not defined')
    const isChunkError = msg?.includes('Failed to fetch dynamically imported module')

    if (isRefError || isChunkError) {
      // Avoid reload loops
      const reloadKey = 'viewer_error_reload'
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1')
        console.warn('[VTE] Stale asset or missing variable error, reloading...', msg)
        window.location.reload()
      }
    }
    // Let Sentry handle reporting
    return false
  }
}

const app = createApp(App)

// Sentry Error Tracking
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT || 'development',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.2 : 0,
    replaysOnErrorSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 1.0 : 0,
  })
}

app.use(i18n)
app.mount('#app')
